import React, { Suspense, useRef } from 'react'
import { useRouter } from 'next/router'
// Sanity
import { getClient } from '../client'
import { propsSanity, groqSanityPageQuery } from '../lib/libFunctions'

// Styles
import { base } from '../styles/base/_allBase.styles'
const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base
// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
// import MarketingPopUp from "../components/pop-up/pop-up-component.jsx";
// import CarouselBoniDay from "../components/carousel-boni-day/carousel-boni-day";
import DragSliderSection from '../components/drag-slider-section/drag-slider-section'
import { HeaderTwoColumGrid } from '../components/header-w-two-column-grid/header-w-two-column-grid'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
// import {HeaderTwoColumGrid} from "../components/"
import { InsetCarouselSection } from '../components/inset-carousel-section/inset-carousel-section' // Default export
function Home(props) {
  const sectionOneRef = useRef()
  const router = useRouter()

  console.log(props.data.data)

  const {
    header,
    headerTwoColumnText,
    section2,
    section3,
    insetCarousel,
    dragSlider,
  } = props.data.data
  const { seo } = props.data

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <Suspense fallback={<div>Loading...</div>}>
            <SectionOne header={header} />
            <HeaderTwoColumGrid data={headerTwoColumnText} />
            <InsetCarouselSection imageArray={insetCarousel.images} moduleId={insetCarousel._key} />
            <HeaderTwoColumGrid data={section2} />
            <DragSliderSection data={dragSlider} />
            <HeaderTwoColumGrid data={section3} />
          </Suspense>
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const query = groqSanityPageQuery('about')
  const data = await getClient().fetch(query, {})

  return {
    props: {
      data: propsSanity(data),
    },
  }
}

export default Home
